import { api } from '@/server';
import { modal } from '@/share/components';
export const useKpiAudit = () => {
  const {
    runAsync: submitKpiAuditApi
  } = fetchApi(api.kpi.kpiAudit.submit, {
    showError: false
  });
  const {
    runAsync: auditKpiApi
  } = fetchApi(api.kpi.kpiAudit.auditKpi, {
    showError: false
  });
  const submitKpiAudit = async kpiId => {
    if (!kpiId) {
      modal.notification.error('指标库ID无效，请重新选择', '审核申请');
      return {
        error: '指标库ID无效，请重新选择'
      };
    }
    const confirm = await modal.confirm('提交审核', '确定提交审核申请吗？提交后将无法再修改，除非审核失败');
    if (!confirm) return {
      error: '取消操作'
    };
    const {
      error,
      taskIds = [],
      userIds = []
    } = await submitKpiAuditApi({
      kpiId
    });
    if (error) {
      modal.notification.error(error, '提交审核失败');
      return {
        error
      };
    }
    modal.notification.success(`提交审核成功`, '提交审核成功');
    return {
      taskIds,
      userIds
    };
  };

  // 审核指标库
  const auditKpi = async (kpiId, state, summary) => {
    const {
      error,
      state: resState
    } = await auditKpiApi({
      kpiId,
      state,
      summary
    });
    if (error) {
      modal.notification.error(error, '审核失败');
      return {
        error
      };
    }
    modal.notification.success(`审核成功`, '审核成功');
    return {
      state: resState
    };
  };
  return {
    submitKpiAudit,
    auditKpi
  };
};